import { Breadcrumbs } from '@mantine/core';
import { ChevronRightIcon } from '@zenos/front-end-ui-icons';
import classNames from './Breadcrumbs.module.css';

// eslint-disable-next-line react-refresh/only-export-components
export default Breadcrumbs.extend({
  classNames,
  defaultProps: { separator: <ChevronRightIcon /> },
});
